import type { Subscription } from '../../../types';

import selectSubscription from '../../../helpers/data/select-subscription';
import useData from '@blueshift-ui/fetch/dist/hooks/use-data';

interface UserSubscriptionsHookProps {
  status?: 'active' | 'expired' | 'inactive' | 'paused' | 'pending';
  userUuid?: string;
}

function useUserSubscriptions({ status, userUuid }: UserSubscriptionsHookProps) {
  return useData<Subscription[] | null>({
    queryKey: ['user-subscriptions', userUuid],
    queryOptions: {
      enabled: Boolean(userUuid),
      select(response: any) {
        const data = response?.data;
        if (!data) {
          return null;
        }

        return data.map(selectSubscription);
      },
    },
    request: {
      params: {
        status,
      },
      url: `/v1/users/${userUuid}/subscriptions`,
    },
  });
}

export default useUserSubscriptions;
